"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _background = _interopRequireDefault(require("../images/asics-perf-jp/background.png"));

var _brandFamilyBlue = _interopRequireDefault(require("../images/asics-perf-jp/brand-family-blue.svg"));

var _iconApp = _interopRequireDefault(require("../images/asics-perf-jp/icon-app.svg"));

var _iconGift = _interopRequireDefault(require("../images/asics-perf-jp/icon-gift.svg"));

var _iconPoints = _interopRequireDefault(require("../images/asics-perf-jp/icon-points.svg"));

var _iconShipping = _interopRequireDefault(require("../images/asics-perf-jp/icon-shipping.svg"));

var _iconStar = _interopRequireDefault(require("../images/asics-perf-jp/icon-star.svg"));

var _stitches = require("../stitches.config");

var images = {
  blackBrandFamily: _brandFamilyBlue.default,
  iconApp: _iconApp.default,
  iconGift: _iconGift.default,
  iconPoints: _iconPoints.default,
  iconShipping: _iconShipping.default,
  iconStar: _iconStar.default
};
var theme = (0, _stitches.createTheme)('asics-perf-jp', {
  background: {
    image: "url(".concat(_background.default, ")")
  },
  sizes: {
    logo: '60%'
  }
});
var _default = {
  images: images,
  theme: theme
};
exports.default = _default;